import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { space } from '@ticketswap/solar'
import { ViewerContext } from '../ViewerContext'
import EmailSent from '../EmailSentIllustration'
import { createMarkup } from '~/utils'

const ConfirmMessage = styled.p`
  margin-top: 0;
  text-align: center;

  strong {
    display: inline-block;
  }
`

export const Illustration = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${space[32]};
`

function LoginLinkSent({ t }) {
  const { email } = React.useContext(ViewerContext)

  return (
    <>
      <Illustration>
        <EmailSent />
      </Illustration>

      <ConfirmMessage
        dangerouslySetInnerHTML={createMarkup(
          t('auth.loginLinkSent.info', {
            email,
          }),
          {
            renderInline: true,
            disableAutolink: true,
          }
        )}
      />
    </>
  )
}

LoginLinkSent.propTypes = {
  t: PropTypes.func.isRequired,
}

export default LoginLinkSent
